export default {
    "Report-1": () => import('@/components/reports/Report1.vue'),
    "Report-2": () => import('@/components/reports/Report2.vue'),
    "Report-3": () => import('@/components/reports/Report3.vue'),
    "Report-4": () => import('@/components/reports/Report4.vue'),
    "Report-5": () => import('@/components/reports/Report5.vue'),
    "Chart-1": () => import('@/components/reports/Chart1.vue')
}